import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import MenuIcon from "components/icons/menu";
import CloseIcon from "components/icons/close";

const MenuIconWrapper = styled.div`
  cursor: pointer;

  svg {
    stroke: ${({ theme }) => theme.themeColors.goodfriendDark};
  }
`;

const MenuWrapper = styled.div`
  padding: 0.5625rem 0 0.5625rem 0.75rem;
  ${({ theme }) => theme.mq.lg`
    display: none;
  `}
`;

const ProviderNavigationMenu = React.forwardRef((props, ref) => {
  const { setHideSide, hideSide } = props;
  return (
    <MenuWrapper>
      <MenuIconWrapper
        aria-label="Open Menu"
        role="button"
        ref={ref}
        onClick={() => {
          setHideSide(!hideSide);
        }}
      >
        {hideSide ? <MenuIcon color="#27272F" /> : <CloseIcon />}
      </MenuIconWrapper>
    </MenuWrapper>
  );
});

export default ProviderNavigationMenu;

ProviderNavigationMenu.propTypes = {
  setHideSide: PropTypes.func,
  hideSide: PropTypes.bool,
};

ProviderNavigationMenu.defaultProps = {
  setHideSide: {},
  hideSide: true,
};
